import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/smiley-attention.svg")